export const formatData = [
  { id: 1, value: '.bin' },
  { id: 2, value: '.xls' },
  { id: 3, value: '.json' },
  { id: 4, value: '.sql' },
  { id: 5, value: '.xml' },
  { id: 6, value: '.txt' },
  { id: 7, value: '.csv' },
]
